import Vue from "vue";
import Router from "vue-router";
import Layout from '../components/main.vue'

Vue.use(Router);

// roles: 权限结构,有这个属性的就是需要权限才能见到的页面；
// hidden: 不需要在左侧菜单页显示的；
// noDropdown: 左侧菜单只有一级菜单

// 默认不需要权限的页面
export const constantRouterMap = [
  {
    path: '*',
    hidden: true,
    component: () => import('../components/404.vue')
  },
  {
    path: '/login',
    hidden: true,
    component: () => import('../components/login.vue')
  },
  // {
  //   path: '/',
  //   hidden: true,
  //   component: Layout,
  //   redirect: '/project/list',
  // },
  {
    path: '/project',
    meta: {
      title: '监测管理',
      icon: 'iconfont icon-shexiangtou',
    },
    redirect: '/project/list',
    component: Layout,
    children: [
      {
        path: 'map',
        meta: {
          title: '工程分布地图',
        },
        component: () => import('../components/main/project/map.vue')
      },
      {
        path: 'list',
        meta: {
          keepAlive: true,
          title: '工程信息清单'
        },
        component: () => import('../components/main/project/list.vue')
      },
      {
        path: 'info/:operation',
        hidden: true,
        meta: {
          title: '新增/修改'
        },
        component: () => import('../components/main/project/info.vue')
      }
    ]
  },
  {
    path: '/document',
    meta: {
      title: '资料管理',
      icon: 'iconfont icon-ziliaoguanli',
    },
    noDropdown: true,
    redirect: '/document/list',
    component: Layout,
    children: [
      {
        path: 'list',
        meta: {
          title: '资料列表'
        },
        component: () => import('../components/main/document/list.vue'),
      },
      {
        path: 'info/:operation',
        hidden: true,
        meta: {
          title: '新增/修改'
        },
        component: () => import('../components/main/document/info.vue'),
      }
    ]
  },
  {
    path: '/message',
    redirect: '/message/advice',
    component: Layout,
    meta: {
      title: '个人消息',
      icon: 'iconfont icon-bell',
    },
    children:[
      {
        path: 'advice',
        meta: {
          title: '站内消息'
        },
        component: () => import('../components/main/message/advice.vue'),
      },
      {
        path: 'send',
        meta: {
          title: '发送消息'
        },
        component: () => import('../components/main/message/sendMessage.vue'),
      },
      {
        path: 'record',
        meta: {
          title: '系统日志'
        },
        component: () => import('../components/main/message/record.vue'),
      },
    ]
  },
  {
    path: '/push',
    name: 'push',
    meta: {
      title: '推送'
    },
    hidden: true,
    redirect: '/push/list',
    component: Layout,
    children: [
      {
        path: 'list',
        meta: {
          title: '推送列表'
        },
        component: () => import('../components/main/push/index.vue')
      }
    ]
  },
  // {
  //   path: '/token',
  //   meta: {
  //     title: '令牌设置'
  //   },
  //   hidden: true,
  //   redirect: '/token/list',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'list',
  //       meta: {
  //         title: '令牌列表'
  //       },
  //       component: () => import('../components/main/setToken/tokenList.vue')
  //     }
  //   ]
  // },
  {
    path: "",
    component: Layout,
    redirect: "/project/list",
    hidden: true,
  },
  {
    path: '/projectInfo',
    meta: {
      title: '工程信息详情'
    },
    hidden: true,
    redirect: '/projectInfo/situationInfo/realTime',
    component: Layout,
    children: [
      {
        path: 'situationInfo',
        component: () => import('../components/main/project_situation/info.vue'),
        children: [
          {
            path: 'diagram',
            meta: {
              title: '工程简图'
            },
            component: () => import('../components/main/project_situation/info-diagram.vue'),
          },
          {
            path: 'history1',
            meta: {
              title: '历史数据'
            },
            component: () => import('../components/main/project_situation/info-history1.vue'),
          },
          {
            path: 'infoMessage',
            meta: {
              title: '消息查询'
            },
            component: () => import('../components/main/project_situation/info-message.vue'),
          },
          {
            path: 'analysis',
            meta: {
              title: '数据趋势'
            },
            component: () => import('../components/main/project_situation/info-analysis.vue'),
          },
          {
            path: 'analysisLink',
            meta: {
              title: '关联分析'
            },
            component: () => import('../components/main/project_situation/info-analysis-link.vue'),
          },
          {
            path: 'realTime',
            meta: {
              title: '实时数据'
            },
            component: () => import('../components/main/project_situation/info-realTime.vue'),
          },
          {
            path: 'alarmMessage',
            meta: {
              title: '预警信息'
            },
            component: () => import('../components/main/project_situation/info-alarm-message.vue'),
          }
        ]
      },
    ]
  }
]

// 异步路由（需要权限的页面）
export const asyncRouterMap = [
  {
    path: '/organization',
    meta: {
      title: '机构管理',
      icon: 'iconfont icon-jigou',
      roles: ['管理员', 'admin']
    },
    noDropdown: true,
    redirect: '/organization/list',
    component: Layout,
    children: [
      {
        path: 'list',
        meta: {
          keepAlive: true ,
          title: '机构列表'
        },
        component: () => import('../components/main/organization/list.vue')
      },
      {
        path: 'info/:operation',
        meta: {
          title: '新增/修改',
        },
        hidden: true,
        component: () => import('../components/main/organization/info.vue')
      }
    ]
  },
  {
    path: '/account',
    meta: {
      title: '人员管理',
      roles: ['管理员', 'admin']
    },
    hidden: true,
    redirect: '/organization/list',
    component: Layout,
    children: [
      {
        path: 'info/:operation',
        meta: {
          title: '新增/修改',
        },
        hidden: true,
        component: () => import('../components/main/account/info.vue')
      }
    ]
  },
  {
    path: '/server',
    meta: {
      title: '采集端管理',
      roles: ['admin'],
      icon: 'iconfont icon-computer',
    },
    noDropdown: true,
    redirect: '/server/list',
    component: Layout,
    children: [
      {
        path: 'list',
        meta: {
          title: '采集端列表'
        },
        component: () => import('../components/main/server/list.vue'),
      },
    ]
  },
  {
    path: '/system',
    meta: {
      title: '系统设置',
      roles: ['admin'],
      icon: 'el-icon-setting',
      style: {
        "fontSize": "1.8em"
      },
    },
    redirect: '/system/list',
    component: Layout,
    children: [
      {
        path: 'list',
        meta: {
          title: '续费设置'
        },
        component: () => import('../components/main/system/list.vue')
      },
      {
        path: 'smsList',
        meta: {
          title: '短信账单'
        },
        component: () => import('../components/main/system/sms-bill.vue')
      },
      {
        path: 'tradeHistory',
        meta: {title: '续费历史'},
        component: () => import('../components/main/system/trade-history.vue')
      }
    ]
  },
  {
    path: '/projectConfig',
    meta: {
      title: '工程配置',
      roles: ['管理员', 'admin']
    },
    hidden: true,
    redirect: '/projectConfig/manage/device/imcList',
    component: Layout,
    children: [
      {
        path: 'manage',
        component: () => import('../components/main/project_manage/info.vue'),
        children: [
          {
            path: 'download',
            meta: {
              title: '报表管理'
            },
            component: () => import('../components/main/project_manage/info-download.vue'),
          },
          {
            path: 'device',
            meta: {
              title: '采集端配置'
            },
            component: () => import('../components/main/project_manage/info-device.vue'),
            children: [
              {
                path: 'imcList',
                meta: {
                  title: 'IMC列表'
                },
                component: () => import('../components/main/project_manage/device/imc-list.vue'),
              },
              {
                path: 'periodList',
                meta: {
                  title: '周期列表'
                },
                component: () => import('../components/main/project_manage/device/period-list'),
              },
              {
                path: 'sctList',
                meta: {
                  title: 'SCT列表'
                },
                component: () => import('../components/main/project_manage/device/imc-edit-sct-list.vue'),
              },
              {
                path: 'sensorList',
                meta: {
                  title: '传感器列表'
                },
                // component: () => import('../components/main/project_edit/sensor/point-sensor.vue')
                component: () => import('../components/main/project_manage/device/imc-edit-sensor-list.vue'),
              },
              {
                path: 'pointList',
                meta: {
                  title: '测点列表'
                },
                component: () => import('../components/main/project_manage/device/rel-point-list.vue'),
              },
              {
                path: 'groupList',
                meta: {
                  title: '点组列表'
                },
                component: () => import('../components/main/project_manage/device/rel-group-list.vue'),
              },
              {
                path: 'alarmDevice',
                meta: {
                  title: '预警设备'
                },
                component: () => import('../components/main/project_manage/device/alarm-device.vue'),
              },
              {
                path: 'dataFilter',
                meta: {
                  title: '数据过滤'
                },
                component: () => import('../components/main/project_manage/device/data-filter.vue'),
              },
              {
                path: 'dataUpload',
                meta: {
                  title: '人工监测数据',
                },
                component: () => import('../components/main/project_manage/device/data-upload.vue')
              }
              // {
              //   path: 'dataImport',
              //   meta: {
              //     title: '数据导入'
              //   },
              //   component: () => import('../components/main/project_manage/device/data-import.vue'),
              // }
            ]
          },
          {
            path: 'list',
            meta: {
              title: '监测项目配置'
            },
            component: () => import('../components/main/project_edit/list.vue'),
          },
          {
            path: 'info/:operation',
            meta: {
              title: '新增/修改'
            },
            component: () => import('../components/main/project_edit/info.vue'),
          },
          {
            path: 'alarm',
            meta: {
              title: '预警和消息'
            },
            component: () => import('../components/main/project_edit/alarm/alarm-manage.vue'),
            children:[
              {
                path: 'alarmSet',
                meta: {
                  title: '预警阈值'
                },
                component: () => import('../components/main/project_edit/alarm/alarm-set.vue'),
              },
              {
                path:'alarmAccount',
                meta: {
                  title: '预警订阅'
                },
                component: () => import('../components/main/project_edit/alarm/alarm-account.vue'),
              },
              {
                path:'messageAccount',
                meta: {
                  title: '消息订阅'
                },
                component: () => import('../components/main/project_edit/alarm/message-account.vue'),
              },
              {
                path: 'alarmTrade',
                meta: {
                  title: '短信续费'
                },
                component:() => import('../components/main/project_edit/alarm/alarm-trade.vue')
              },
              {
                path: 'smsHistory',
                meta: {
                  title: '短信发送历史'
                },
                component: () => import('../components/main/project_edit/alarm/sms-history.vue')
              }
            ]
          },
          {
            path:'pointDisplay',
            meta: {
              title: '测点权限'
            },
            component: () => import('../components/main/project_edit/point-display.vue'),
          },
          {
            // 巡检记录列表
            path: 'checkList',
            meta: {
              title: '巡检记录'
            },
            component: () => import('../components/main/project_manage/info-check-list.vue'),
          },
          {
            // 巡检记录添加/修改
            path: 'checkList/:operation',
            meta: {
              title: '新增/修改'
            },
            component: () => import('../components/main/project_manage/info-check-info.vue'),
          }
        ]
      },
    ]
  },
]

//注册路由
const createRouter = () => new Router({
  routes: constantRouterMap,
})

const router = createRouter();

// 重置路由，避免高权限账号退出登录再登入低权限账号时，通过浏览器地址栏仍然能访问未开放页面
// 20240125，已废弃，在登录页执行此方法时，会导致路由登录进工程列表页重复执行多次，token失效或退出登录时使用window.location.reload()。
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js